<template>
    <v-container max-width="100%" fluid style="margin-top: 2%;">
    <LoadingComponent :loading="loadingImportacao" :message="$t('crudSchedule.messages.importing')" />
      <!-- Dialogo de confirmação de exclusão de escala-->
      <template>
        <v-row justify="center">
          <v-dialog v-model="confirmDialogEscala" persistent max-width="500" style="border-radius: 10px;">
            <v-card>
              <v-card-title class="headline">
                <span style="color: #d60000">{{ $t('system.alert') }}</span>
              </v-card-title>
              <v-card-text>
                <span style="color: #d60000">{{ this.mensagemdialog }}</span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red accent-4"
                  class="white--text"
                  @click="confirmDialogEscala = false"
                  >{{ this.messageDismissButton }}</v-btn
                >
                <v-btn
                  v-if="showConfirmButton"
                  color="red accent-4"
                  class="white--text"
                  @click="deleteEscalaFromDatabase"
                  >{{ this.messageConfirmButton }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

    <!-- Dialogo de confirmação de substituição de escala-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialogSubst" persistent max-width="500" style="border-radius: 10px;">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="closeConfirmSubst">{{ this.messageDismissButton
                }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="substEscalaAtiva">{{
                this.messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Dialogo de confirmação de importação de escalas -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialogImportacao" persistent max-width="500" style="border-radius: 10px;">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #4a4a4a">{{ $t('crudSchedule.messages.processingResult') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #4a4a4a">{{ this.mensagemProcessamentoImportacao }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="white--text" @click="confirmDialogImportacao = false">{{
                $t('crudSchedule.messages.cancel') }}</v-btn>
              <v-btn v-if="showImportButton" color="primary" class="white--text" @click="importarEscalas">{{
                $t('crudSchedule.messages.import') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>




    <v-container>
      <!-- Tabela de escalas -->
      <merus-data-table
        :headers="headersEscalasWithProperties"
        :items="escalas"
        :mostrar-inativos="mostrarInativos"
        item-key="id_escala"
        show-expand
        @update:displayedItems="displayedItemsForExport = $event"
        :single-expand="true"
        :loading="loadingEscalas"
        :default-multi-sort="defaultSortEscalas"
        :loading-text="$t('groups.loading')" cod-tabela="ESCALAS__ESCALAS_WITH_PROPERTIES" @update:headers="headersEscalasWithProperties = $event">
        <template v-slot:expanded-item="{ headers, item }">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>{{ $t('schedule.headers.main.expandedItem.beginTime') }}</th>
                  <th>{{ $t('schedule.headers.main.expandedItem.endTime') }}</th>
                  <th>{{ $t('schedule.headers.main.expandedItem.direction') }}</th>
                  <th>{{ $t('schedule.headers.main.expandedItem.turn') }}</th>
                  <th>{{ $t('schedule.headers.main.expandedItem.escalation') }}</th>
                  <th>{{ $t('schedule.headers.main.expandedItem.driver') }}</th>
                  <th>{{ $t('schedule.headers.main.expandedItem.collector') }}</th>
                  <th>{{ $t('schedule.headers.main.expandedItem.vehicle') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="viagem in item.viagens" :key="viagem.id_viagem">
                  <td>{{ viagem.horario_saida }}</td>
                  <td>{{ viagem.horario_chegada }}</td>
                  <td>{{ viagem.descricao_sentido }}</td>
                  <td>{{ viagem.descricao_turno }}</td>
                  <td>{{ viagem.escalonamento }}</td>
                  <td>{{ viagem.nome_motorista }}</td>
                  <td>{{ viagem.nome_cobrador }}</td>
                  <td>{{ viagem.numero_ordem }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>
        <template v-slot:toolbar>
          <CadastroToolbar :token="token" :user="user.id_usuario" :title="$t('schedule.title')" hide-search
            :items="displayedItemsForExport !== null ? displayedItemsForExport : escalasFiltradas" :csv-title="$t('schedule.title')" :csv-headers="headersCSV" :pdf-title="$t('schedule.title')"
            :pdf-headers="headersEscalasWithProperties" :pdf-filename="$t('schedule.title')" :help-dialog-csv-fields="helpCSV"
            :help-dialog-csv-model="$tc('crudSchedule.title')" :endpoint-upload-csv="canEdit || canInsert ? '/api/v1.0/processacsvescalas/' : null" @saveBulk="saveEscalaFromCsv">
            <template v-slot:extension>
              <v-switch
                v-model="mostrarInativos"
                :label="$t('crudVeiculos.showInactive')"
                class="ml-3 mr-4"
                hide-details
              ></v-switch>
            </template>
            <template v-slot:add v-if="canInsert">
              <v-dialog v-model="escalasDialog" max-width="100%">
                <!-- botão para mostrar o dialog de cadastro/edição de escalas -->
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                  </template>
                <v-card>
                <v-card-title>
                  <span class="headline" style="color: #4a4a4a">{{
                    formTitleEscala
                  }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row>
                        <v-col cols="12" sm="10" md="12">
                          <v-text-field v-model="editedEscala.descricao" :label="$t('schedule.description')"
                            :rules="[(v) => !!v || $t('schedule.descriptionRequired')]"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="4">
                          <v-datetime-picker :label="$t('datetime.startValidity')" v-model="inicioVigencia"
                            ref="inicioVigenciaInput" :time-picker-props="timeProps"
                            :text-field-props="textFieldPropsInicio" :time-format="$t('datetime.timeFormat')"
                            :date-format="$t('datetime.dateFormat')" :clear-text="$t('datetime.close')"
                            :disabled="isInicioDisabled">
                            <template slot="dateIcon">
                              <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                              <v-icon>mdi-clock</v-icon>
                            </template>
                          </v-datetime-picker>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                          <v-datetime-picker :label="$t('datetime.endValidity')" v-model="fimVigencia"
                            ref="fimVigenciaInput" :time-picker-props="timeProps" :text-field-props="textFieldPropsFim"
                            :time-format="$t('datetime.timeFormat')" :date-format="$t('datetime.dateFormat')"
                            :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                              <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                              <v-icon>mdi-clock</v-icon>
                            </template>
                          </v-datetime-picker>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                          <v-autocomplete v-model="quadroSelected" :items="quadros" return-object item-text="descricao"
                            :label="$tc('timeTable.self', 1)" @change="quadroChanged"
                            :disabled="isQuadroDisabled"></v-autocomplete>
                        </v-col>
                      </v-row>
                      <div id="frequenciaescala">
                        <v-row>
                          <span class="headline"
                            :style="[isFrequenciaDisabled ? { 'color': 'gray' } : { 'color': 'primary' }]">{{
                              $t('system.labels.frequency') }}</span>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="4" md="1">
                            <v-checkbox v-model="editedEscala.valido_segunda" :label="$t('datetime.weekdays.monday')"
                              color="primary" :disabled="isFrequenciaDisabled"></v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="4" md="1">
                            <v-checkbox v-model="editedEscala.valido_terca" :label="$t('datetime.weekdays.tuesday')"
                              color="primary" :disabled="isFrequenciaDisabled"></v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="4" md="1">
                            <v-checkbox v-model="editedEscala.valido_quarta" :label="$t('datetime.weekdays.wednesday')"
                              color="primary" :disabled="isFrequenciaDisabled"></v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="4" md="1">
                            <v-checkbox v-model="editedEscala.valido_quinta" :label="$t('datetime.weekdays.thursday')"
                              color="primary" :disabled="isFrequenciaDisabled"></v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="4" md="1">
                            <v-checkbox v-model="editedEscala.valido_sexta" :label="$t('datetime.weekdays.friday')"
                              color="primary" :disabled="isFrequenciaDisabled"></v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="4" md="1">
                            <v-checkbox v-model="editedEscala.valido_sabado" :label="$t('datetime.weekdays.saturday')"
                              color="primary" :disabled="isFrequenciaDisabled"></v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="4" md="1">
                            <v-checkbox v-model="editedEscala.valido_domingo" :label="$t('datetime.weekdays.sunday')"
                              color="primary" :disabled="isFrequenciaDisabled"></v-checkbox>
                          </v-col>
                        </v-row>
                      </div>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">

                          <!-- Tabela de viagens por escala -->
                          <v-data-table :headers="headersViagens" :items="editedEscala.viagens" :search="search"
                            sort-by="id_viagem" dense class="elevation-7" locale="pt" style="border-radius: 10px;">

                            <template v-slot:top>
                              <v-toolbar flat color="white" style="border-radius: 10px;">
                                <v-toolbar-title style="color: #4a4a4a; margin-right: 10px;">{{ viagensTableTitle
                                  }}</v-toolbar-title>
                                <v-checkbox v-model="repetirEscalonamento" :label="$t('schedule.repeatByEscalation')"
                                  hide-details></v-checkbox>

                                <v-spacer></v-spacer>

                                <vue-json-to-csv :json-data="editedEscala.viagens"
                                  :csv-title="`viagensescala${editedEscala.id_escala}`" separator=";">
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                                        <v-icon>mdi-export-variant</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>{{ $t('system.labels.exportToCsv') }}</span>
                                  </v-tooltip>
                                </vue-json-to-csv>

                                <ExportTablePdf :title="viagensTableTitle" :content="editedEscala.viagens"
                                  :headers="headersViagens" filename="viagensescala"></ExportTablePdf>
                              </v-toolbar>
                            </template>
                            <template v-slot:item.nome_motorista="{ item }">
                              <v-autocomplete v-model="item.id_funcionario_motorista" :items="funcionarios"
                                item-text="label" item-value="id_funcionario" solo dense hide-details
                                style="margin-top: 10px; margin-bottom: 10px;"
                                @change="motoristaChanged(item)"></v-autocomplete>
                            </template>
                            <template v-slot:item.nome_cobrador="{ item }">
                              <v-autocomplete v-model="item.id_funcionario_cobrador" :items="funcionarios"
                                item-text="label" item-value="id_funcionario" solo dense hide-details
                                style="margin-top: 10px; margin-bottom: 10px;"
                                @change="cobradorChanged(item)"></v-autocomplete>
                            </template>
                            <template v-slot:item.numero_ordem="{ item }">
                              <v-autocomplete v-model="item.id_veiculo" :items="veiculos" item-text="numero_ordem"
                                item-value="id_veiculo" solo dense hide-details
                                style="margin-top: 10px; margin-bottom: 10px;"
                                @change="veiculoChanged(item)"></v-autocomplete>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-textarea v-model="editedEscala.observacoes" :label="$tc('system.labels.observation', 2)"
                            auto-grow clearable counter rows="1"
                            :rules="[(v) => (v == null || (typeof v === 'string' && v.length <= 1000)) || $t('schedule.invalidObservations')]"></v-textarea>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary darken-1" class="white--text" @click="closeEscala">{{ $t('button.cancel')
                    }}</v-btn>
                  <v-btn color="primary darken-1" class="white--text" @click="saveEscala">{{ $t('button.save')
                    }}</v-btn>
                </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
          </CadastroToolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" color="green" @click.stop="editEscala(item)"
            :disabled="!item.ativo || !canEdit || !canInsert">mdi-pencil</v-icon>
          <v-icon small class="mr-2" color="red" @click.stop="deleteEscala(item)"
            :disabled="!item.ativo || !canDelete">mdi-delete</v-icon>
        </template>
      </merus-data-table>
    </v-container>
  </v-container>
</template>

<style lang="css">
 
</style>
    
  <script>

import apiController from "@/utils/apiController";
import ExportTablePdf from "./ExportTablePdf.vue";
import VueJsonToCsv from "vue-json-to-csv";
import DateUtils from "../utils/dateutils";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import LoadingComponent from "./LoadingComponent.vue";
import EventBus from '../utils/eventBus';
import translateDbField from "@/utils/translateDbField";

export default {
  components: { ExportTablePdf, VueJsonToCsv, CadastroToolbar, MerusDataTable, LoadingComponent },
  data: () => ({
    headersEscalasWithProperties: [],
    search: "",
    user: null,
    token: null,
    erro: null,
    showConfirmButton: true,
    formValidado: true,
    formViagemValidado: true,
    showAlert: false,
    mensagemAlerta: "",
    mensagemUpload: "",
    tipoAlerta: "success",
    escalasDialog: false,
    viagensDialog: false,
    operacao: 0,
    isAtivo: false,
    confirmDialogEscala: false,
    confirmDialogViagem: false,
    confirmDialogSubst: false,
    confirmDialogImportacao: false,
    escalasImportacao: [],
    mensagemProcessamentoImportacao: "",
    showImportButton: false,
    loadingImportacao: false,
    escalaOriginal: null,
    mensagemdialog: "",
    horaProgramada: null,
    isEscalaDisabled: false,
    loadingEscalas: false,
    isEmpresaDisabled: false,
    isLinhaDisabled: false,
    isCategoriaDisabled: false,
    isFrequenciaDisabled: false,
    isViagensDisabled: false,
    isInicioDisabled: false,
    isQuadroDisabled: false,
    inicioVigencia: null,
    fimVigencia: null,
    frequencia: [],
    substitute: false,
    uploadMessageColor: 'primary',

    textFieldPropsFim: {
      prependInnerIcon: "mdi-calendar",
    },
    timeProps: {
      useSeconds: false,
    },
    sentidos: [],
    turnos: [],
    escalas: [],
    mostrarInativos: false,
    displayedItemsForExport: null,
    escalasAtivas: [],
    viagens: [],
    empresas: [],
    linhas: [],
    linhasSelect: [],
    funcionarios: [],
    veiculos: [],
    categorias: [],
    quadros: [],
    empresaSelected: null,
    editedIndexEscala: -1,
    editedEscala: {
      id_escala: null,
      descricao: null,
      ativo: 1,
      ativo_extenso: null,
      descricao_categoria: null,
      dt_inicio_vigencia: null,
      dt_inicio_vigencia_extenso: null,
      dt_fim_vigencia: null,
      dt_fim_vigencia_extenso: null,
      valido_segunda: 0,
      valido_terca: 0,
      valido_quarta: 0,
      valido_quinta: 0,
      valido_sexta: 0,
      valido_sabado: 0,
      valido_domingo: 0,
      id_quadro: null,
      viagens: [],
      observacoes: null,
    },
    deletedEscala: {
      id_escala: null,
      descricao: null,
      ativo: 1,
      ativo_extenso: null,
      descricao_categoria: null,
      dt_inicio_vigencia: null,
      dt_inicio_vigencia_extenso: null,
      dt_fim_vigencia: null,
      dt_fim_vigencia_extenso: null,
      valido_segunda: 0,
      valido_terca: 0,
      valido_quarta: 0,
      valido_quinta: 0,
      valido_sexta: 0,
      valido_sabado: 0,
      valido_domingo: 0,
      id_quadro: null,
      viagens: [],
      observacoes: null,
    },
    defaultEscala: {
      id_escala: null,
      descricao: null,
      ativo: 1,
      ativo_extenso: null,
      descricao_categoria: null,
      dt_inicio_vigencia: null,
      dt_inicio_vigencia_extenso: null,
      dt_fim_vigencia: null,
      dt_fim_vigencia_extenso: null,
      valido_segunda: 0,
      valido_terca: 0,
      valido_quarta: 0,
      valido_quinta: 0,
      valido_sexta: 0,
      valido_sabado: 0,
      valido_domingo: 0,
      id_quadro: null,
      viagens: [],
      observacoes: null,
    },
    editedIndexViagem: -1,
    editedViagem: {
      id_viagem: null,
      id_escala: null,
      horario_saida: null,
      horario_chegada: null,
      id_sentido: null,
      descricao_sentido: null,
      id_turno: null,
      descricao_turno: null,
      escalonamento: null,
      id_funcionario_motorista: null,
      nome_motorista: null,
      matricula_motorista: null,
      id_funcionario_cobrador: null,
      nome_cobrador: null,
      matricula_cobrador: null,
      id_veiculo: null,
      numero_ordem: null,
    },
    deletedViagem: {
      id_viagem: null,
      id_escala: null,
      horario_saida: null,
      horario_chegada: null,
      id_sentido: null,
      descricao_sentido: null,
      id_turno: null,
      descricao_turno: null,
      escalonamento: null,
      id_funcionario_motorista: null,
      nome_motorista: null,
      matricula_motorista: null,
      id_funcionario_cobrador: null,
      nome_cobrador: null,
      matricula_cobrador: null,
      id_veiculo: null,
      numero_ordem: null,
    },
    defaultViagem: {
      id_viagem: null,
      id_escala: null,
      horario_saida: null,
      horario_chegada: null,
      id_sentido: null,
      descricao_sentido: null,
      id_turno: null,
      descricao_turno: null,
      escalonamento: null,
      id_funcionario_motorista: null,
      nome_motorista: null,
      matricula_motorista: null,
      id_funcionario_cobrador: null,
      nome_cobrador: null,
      matricula_cobrador: null,
      id_veiculo: null,
      numero_ordem: null,
    },
    quadroSelected: null,
    repetirEscalonamento: true,
    viagensPrevistas: [],
    recursos: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
  }),
  computed: {
    escalasFiltradas() {
      if (!this.mostrarInativos) {
        return this.escalas.filter((e) => e.ativo === true || e.ativo === 1);
      }
      return this.escalas;
    },
    formTitleEscala() {
      return this.editedIndexEscala === -1 ? this.$t('schedule.register') : this.$t('schedule.edit');
    },
    formTitleViagem() {
      return this.editedIndexViagem === -1 ? this.$t('schedule.registerViagem') : this.$t('schedule.editViagem');
    },
    viagensTableTitle() {
      return this.editedIndexEscala === -1 ? this.$t('nav.realTime.trips') : this.$t('crudQuadros.form.tripsTableTitle.withDescription', { description: this.editedEscala.descricao });
    },
    dataAtual() {
      var dtAtual = new Date().toJSON().slice(0, 10);
      return dtAtual;
    },
    textFieldPropsInicio() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      };
    },
    messageConfirmButton() {
      return this.$t('button.confirm');
    },
    messageDismissButton() {
      return this.$t('button.dismiss');
    },
    defaultSortEscalas() {
      return [
        { value: 'ativo', options: { text: this.$t('system.labels.decreasing'), value: -1 } },
      ];
    },
    turnosFiltrados() {
      const idLinha = this.quadroSelected && this.quadroSelected.id_linha;
      if (!idLinha) {
        return this.turnos;
      }
      const linha = (this.linhas || []).find((l) => Number(l.id_linha) === Number(idLinha));
      const ids = linha && Array.isArray(linha.unidades)
        ? linha.unidades.map((x) => Number(x)).filter((x) => !Number.isNaN(x))
        : [];
      if (!ids.length) {
        return this.turnos;
      }
      return this.turnos.filter(
        (t) => !t.id_unidade || ids.includes(Number(t.id_unidade))
      );
    },
    headersViagens() {
      return [
        { text: this.$t('schedule.headers.trips.idtrip'), value: "id_viagem", align: " d-none" },
        { text: this.$t('schedule.headers.main.expandedItem.beginTime'), value: "horario_saida" },
        { text: this.$t('schedule.headers.main.expandedItem.endTime'), value: "horario_chegada" },
        { text: this.$t('schedule.headers.main.expandedItem.direction'), value: "descricao_sentido" },
        { text: this.$t('schedule.headers.main.expandedItem.turn'), value: "descricao_turno" },
        { text: this.$t('schedule.headers.main.expandedItem.escalation'), value: "escalonamento" },
        { text: this.$t('schedule.headers.main.expandedItem.driver'), value: "nome_motorista", width: "20%", align: "center" },
        { text: this.$t('schedule.headers.main.expandedItem.collector'), value: "nome_cobrador", width: "20%", align: "center" },
        { text: this.$t('schedule.headers.main.expandedItem.vehicle'), value: "numero_ordem", width: "20%", align: "center" },
      ];
    },
    headersCSV() {
      return [
        { text: this.$t('csv.lineNumber'), value: "line_number", error: "error_line" },
        { text: this.$tc('company.self', 1), value: "cod_empresa", error: "error_empresa" },
        { text: this.$tc('line.self', 1), value: "cod_linha", error: "error_linha" },
        { text: this.$t('system.labels.description'), value: "descricao", error: "error_descricao" },
        { text: this.$t('datetime.startValidity'), value: "dt_inicio_vigencia", error: "error_dt_inicio", warning: "warning_dt_inicio" },
        { text: this.$t('datetime.endValidity'), value: "dt_fim_vigencia", error: "error_dt_fim", warning: "warning_dt_fim" },
        { text: this.$t('datetime.weekdays.monday'), value: "valido_segunda", error: "error_valido_segunda" },
        { text: this.$t('datetime.weekdays.tuesday'), value: "valido_terca", error: "error_valido_terca" },
        { text: this.$t('datetime.weekdays.wednesday'), value: "valido_quarta", error: "error_valido_quarta" },
        { text: this.$t('datetime.weekdays.thursday'), value: "valido_quinta", error: "error_valido_quinta" },
        { text: this.$t('datetime.weekdays.friday'), value: "valido_sexta", error: "error_valido_sexta" },
        { text: this.$t('datetime.weekdays.saturday'), value: "valido_sabado", error: "error_valido_sabado" },
        { text: this.$t('datetime.weekdays.sunday'), value: "valido_domingo", error: "error_valido_domingo" },
        { text: this.$tc('trip.self', 1), value: "slot_viagem", error: "error_slot_viagem" },
        { text: this.$t('schedule.headers.main.expandedItem.driver'), value: "matricula_motorista", error: "error_motorista" },
        { text: this.$t('schedule.headers.main.expandedItem.collector'), value: "matricula_cobrador", error: "error_cobrador" },
        { text: this.$t('schedule.headers.main.expandedItem.vehicle'), value: "cod_veiculo", error: "error_veiculo" }];
    },
    helpCSV() {
      return [
        {
          label: this.$t('crudSchedule.csvHelp.companyCode.label'),
          description: this.$t('crudSchedule.csvHelp.companyCode.description'),
          example: this.$t('crudSchedule.csvHelp.companyCode.example'),
          key: "cod_empresa"
        },
        {
          label: this.$t('crudSchedule.csvHelp.lineCode.label'),
          description: this.$t('crudSchedule.csvHelp.lineCode.description'),
          example: this.$t('crudSchedule.csvHelp.lineCode.example'),
          key: "cod_linha"
        },
        {
          label: this.$t('crudSchedule.csvHelp.description.label'),
          description: this.$t('crudSchedule.csvHelp.description.description'),
          example: this.$t('crudSchedule.csvHelp.description.example'),
          key: "descricao"
        },
        {
          label: this.$t('crudSchedule.csvHelp.startValidity.label'),
          description: this.$t('crudSchedule.csvHelp.startValidity.description'),
          example: this.$t('crudSchedule.csvHelp.startValidity.example'),
          key: "dt_inicio_vigencia"
        },
        {
          label: this.$t('crudSchedule.csvHelp.endValidity.label'),
          description: this.$t('crudSchedule.csvHelp.endValidity.description'),
          example: this.$t('crudSchedule.csvHelp.endValidity.example'),
          key: "dt_fim_vigencia"
        },
        {
          label: this.$t('crudSchedule.csvHelp.monday.label'),
          description: this.$t('crudSchedule.csvHelp.monday.description'),
          example: this.$t('crudSchedule.csvHelp.monday.example'),
          key: "valido_segunda"
        },
        {
          label: this.$t('crudSchedule.csvHelp.tuesday.label'),
          description: this.$t('crudSchedule.csvHelp.tuesday.description'),
          example: this.$t('crudSchedule.csvHelp.tuesday.example'),
          key: "valido_terca"
        },
        {
          label: this.$t('crudSchedule.csvHelp.wednesday.label'),
          description: this.$t('crudSchedule.csvHelp.wednesday.description'),
          example: this.$t('crudSchedule.csvHelp.wednesday.example'),
          key: "valido_quarta"
        },
        {
          label: this.$t('crudSchedule.csvHelp.thursday.label'),
          description: this.$t('crudSchedule.csvHelp.thursday.description'),
          example: this.$t('crudSchedule.csvHelp.thursday.example'),
          key: "valido_quinta"
        },
        {
          label: this.$t('crudSchedule.csvHelp.friday.label'),
          description: this.$t('crudSchedule.csvHelp.friday.description'),
          example: this.$t('crudSchedule.csvHelp.friday.example'),
          key: "valido_sexta"
        },
        {
          label: this.$t('crudSchedule.csvHelp.saturday.label'),
          description: this.$t('crudSchedule.csvHelp.saturday.description'),
          example: this.$t('crudSchedule.csvHelp.saturday.example'),
          key: "valido_sabado"
        },
        {
          label: this.$t('crudSchedule.csvHelp.sunday.label'),
          description: this.$t('crudSchedule.csvHelp.sunday.description'),
          example: this.$t('crudSchedule.csvHelp.sunday.example'),
          key: "valido_domingo"
        },
        {
          label: this.$t('crudSchedule.csvHelp.tripSlot.label'),
          description: this.$t('crudSchedule.csvHelp.tripSlot.description'),
          example: this.$t('crudSchedule.csvHelp.tripSlot.example'),
          key: "slot_viagem"
        },
        {
          label: this.$t('crudSchedule.csvHelp.driverRegistration.label'),
          description: this.$t('crudSchedule.csvHelp.driverRegistration.description'),
          example: this.$t('crudSchedule.csvHelp.driverRegistration.example'),
          key: "matricula_motorista"
        },
        {
          label: this.$t('crudSchedule.csvHelp.collectorRegistration.label'),
          description: this.$t('crudSchedule.csvHelp.collectorRegistration.description'),
          example: this.$t('crudSchedule.csvHelp.collectorRegistration.example'),
          key: "matricula_cobrador"
        },
        {
          label: this.$t('crudSchedule.csvHelp.vehicleCode.label'),
          description: this.$t('crudSchedule.csvHelp.vehicleCode.description'),
          example: this.$t('crudSchedule.csvHelp.vehicleCode.example'),
          key: "cod_veiculo"
        }];
    }
  },
  watch: {
    inicioVigencia(val) {
      if (!val) {
        this.$refs.inicioVigenciaInput.clearHandler();
      }
    },
    fimVigencia(val) {
      if (!val) {
        this.$refs.fimVigenciaInput.clearHandler();
      }
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
      this.$refs.form.resetValidation();
      }
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaRecursos();
  },
  mounted() {
    this.$root.$emit('eventshowback', true);
  },
  methods: {

    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.initialize();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updateescala");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertescala");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deleteescala");
            this.initialize();
          },
        });
      }
    },
    initialize() {
      this.loadingEscalas = true;
      apiController.request(apiController.endpoints.getallEscalas, {
        silent: true,
        onSuccess: (response) => {
          this.escalas = response.data;
          this.populaViagens();
        },
        onError: (e) => {
          this.loadingEscalas = false
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          this.erro = {
            type: "Axios",
            message: e.message,
            status: e.response.status
          };
          this.$refs.erroDialog.showError();
        },
      });
        this.populaLinhas();
        this.populaEmpresas();
        this.populaSentidos();
        this.populaTurnos();
        this.populaQuadros();
        this.populaFuncionarios();
        this.populaVeiculos();
        this.populaViagensPrevistas();
    },
    populaViagens() {
      apiController.request(apiController.endpoints.getallViagensescalas, {
        onSuccess: (response) => {
          this.escalas = this.escalas.map((q) => {
            q.viagens = response.data.filter((v) => v.id_escala === q.id_escala);
            return q;
          });
          this.escalasAtivas = this.escalas.filter((q) => q.ativo === 1);
          this.loadingEscalas = false;
        },
        onError: () => {
          this.loadingEscalas = false;
        },
      });
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        silent: true,
        onSuccess: (response) => {
          this.empresas = response.data;
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          this.erro = {
            type: "Axios",
            message: e.message,
            status: e.response.status
          };
          this.$refs.erroDialog.showError();
        },
      });
    },
    populaFuncionarios() {
      apiController.request(apiController.endpoints.getallFuncionarios, {
        onSuccess: (response) => {
          this.funcionarios = response.data;
        },
      });
    },
    populaVeiculos() {
      apiController.request(apiController.endpoints.getallVeiculosativos, {
        onSuccess: (response) => {
          this.veiculos = response.data;
        },
      });
    },
    populaLinhas() {
      apiController.request(apiController.endpoints.getLinhasativas, {
        onSuccess: (response) => {
          this.linhas = response.data;
        },
      });
    },
    populaSentidos() {
      apiController.request(apiController.endpoints.getallSentidos, {
        onSuccess: (response) => {
          const translated = translateDbField(
            response.data.translation_key,
            response.data.descricao_sentido
          );
          this.sentidos = response.data.map((sentido) => {
            return {
            ...sentido,
            descricao_sentido: translated
            };
          });
        },
      });
    },
    populaTurnos() {
      apiController.request(apiController.endpoints.getallTurnos, {
        onSuccess: (response) => {
          this.turnos = response.data;
        },
      });
    },
    populaQuadros() {
      apiController.request(apiController.endpoints.getallQuadros, {
        onSuccess: (response) => {
          // Use editavel (fim vigência ainda não passou), not ativo (exige início <= hoje).
          // Quadros com vigência futura ficam de fora se filtrarmos só por ativo.
          this.quadros = response.data.filter((q) => q.cancelado != 1 && q.editavel == 1);
        },
      });
    },
    populaLinhasSelect(id_empresa) {
      this.linhasSelect = this.linhas.filter((l) => l.id_empresa === id_empresa);
    },
    empresaChanged() {
      this.populaLinhasSelect(this.empresaSelected);
    },
    horarioRules(hora) {
      if (hora == null) {
        return this.$t('datetime.requiredTime');
      }
      else {
        if (hora.length === 0) {
          return this.$t('datetime.requiredTime');
        }
        else {
          if (!/(([01][0-9])|(2[0-3])):([0-5][0-9])$/.test(hora)) {
            return this.$t('datetime.invalidTime');
          }
          else {
            return true;
          }
        }
      }
    },
    cloneEscalaForEdit(escala) {
      return {
        ...escala,
        viagens: (escala.viagens || []).map((v) => ({ ...v })),
      };
    },
    editEscala(escala) {
      this.escalaOriginal = this.cloneEscalaForEdit(escala);
      this.editedIndexEscala = this.escalas.indexOf(escala);
      this.editedEscala = this.cloneEscalaForEdit(escala);
      this.inicioVigencia = this.editedEscala.dt_inicio_vigencia === null ? null : new Date(this.editedEscala.dt_inicio_vigencia);
      this.fimVigencia = this.editedEscala.dt_fim_vigencia === null ? null : new Date(this.editedEscala.dt_fim_vigencia);
      this.empresaSelected = this.editedEscala.id_empresa;
      this.quadroSelected = this.resolveQuadroForEscala(this.editedEscala);
      this.populaLinhasSelect(this.empresaSelected);
      this.escalasDialog = true;
    },
    resolveQuadroForEscala(escala) {
      if (!escala || escala.id_quadro == null) {
        return null;
      }
      const quadro = this.quadros.find((q) => q.id_quadro === escala.id_quadro);
      if (quadro) {
        return quadro;
      }
      const fallback = {
        id_quadro: escala.id_quadro,
        descricao: escala.descricao_quadro || String(escala.id_quadro),
      };
      this.quadros = [...this.quadros, fallback];
      return fallback;
    },
    editViagem(viagem) {
      this.editedIndexViagem = this.viagens.indexOf(viagem);
      this.editedViagem = Object.assign({}, viagem);
      this.editedViagem.id_escala = this.editedEscala.id_escala;
      this.viagensDialog = true;
    },
    deleteEscala(escala) {
      this.deletedEscala = Object.assign({}, escala);
      this.mensagemdialog =
        this.$t('schedule.confirmDelete', { schedule: escala.descricao });
      this.showConfirmButton = true;
      this.confirmDialogEscala = true;
    },
    cancelEscala(escala, onSuccess, onError) {
      const escalaCancel = Object.assign({}, escala);
      if (escalaCancel.dt_inicio_vigencia && escalaCancel.dt_inicio_vigencia > new Date().toISOString()) {
        escalaCancel.dt_inicio_vigencia = DateUtils.getDateSQLFormatted(new Date());
        escalaCancel.dt_fim_vigencia = escalaCancel.dt_inicio_vigencia;
        apiController.request(apiController.endpoints.updateEscala, {
          data: escalaCancel,
          onSuccess,
          onError,
        });
      } else {
        apiController.request(apiController.endpoints.desativaEscala, {
          data: { id_escala: escalaCancel.id_escala },
          onSuccess,
          onError,
        });
      }
    },
    deleteEscalaFromDatabase() {
      this.operacao = 3;
      this.confirmDialogEscala = false;
      this.cancelEscala(
        this.deletedEscala,
        (response) => {
          this.updateEscalasTable(response.data.erro);
        },
        (e) => {
          console.log(e);
        }
      );
    },
    closeEscala() {
      if (this.escalasDialog) {
        this.escalasDialog = false;
        this.$nextTick(() => {
          this.editedEscala = Object.assign({}, this.defaultEscala);
          this.deletedEscala = Object.assign({}, this.defaultEscala);
          this.escalaOriginal = null;
          this.editedIndexEscala = -1;
          this.empresaSelected = null;
          this.quadroSelected = null;
          this.isFrequenciaDisabled = false;
          this.isQuadroDisabled = false;
          this.isViagensDisabled = false;
          this.isEmpresaDisabled = false;
          this.isLinhaDisabled = false;
          this.isCategoriaDisabled = false;
          this.isInicioDisabled = false;
          this.isAtivo = false;
          this.inicioVigencia = null;
          this.fimVigencia = null;
          this.$refs.form.resetValidation();
        });
      }
    },
    parseHorarioToMinutes(horario) {
      if (horario == null || horario === "") return null;
      const m = String(horario).trim().match(/^(\d{1,2}):(\d{2})/);
      if (!m) return null;
      return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
    },
    tripTimeRanges(horario_saida, horario_chegada) {
      const start = this.parseHorarioToMinutes(horario_saida);
      const end = this.parseHorarioToMinutes(horario_chegada);
      if (start == null || end == null) return [];
      const DAY = 24 * 60;
      if (end >= start) return [[start, end]];
      return [[start, DAY], [0, end]];
    },
    rangesOverlapPair(a, b) {
      return a[0] < b[1] && b[0] < a[1];
    },
    viagensHorarioOverlap(va, vb) {
      const ra = this.tripTimeRanges(va.horario_saida, va.horario_chegada);
      const rb = this.tripTimeRanges(vb.horario_saida, vb.horario_chegada);
      for (const a of ra) {
        for (const b of rb) {
          if (this.rangesOverlapPair(a, b)) return true;
        }
      }
      return false;
    },
    vigenciaToMs(d) {
      if (d == null) return null;
      const x = d instanceof Date ? d : new Date(d);
      const t = x.getTime();
      return isNaN(t) ? null : t;
    },
    isEscalaWithinVigencia(escala) {
      if (!escala || escala.dt_inicio_vigencia == null) return false;
      const now = Date.now();
      const inicio = this.vigenciaToMs(escala.dt_inicio_vigencia);
      if (inicio == null || now < inicio) return false;
      if (escala.dt_fim_vigencia == null) return true;
      const fim = this.vigenciaToMs(escala.dt_fim_vigencia);
      return fim != null && now <= fim;
    },
    buildEscalaPayloadFromForm(includeId = false) {
      const payload = {
        descricao: this.editedEscala.descricao,
        dt_inicio_vigencia: this.inicioVigencia
          ? DateUtils.getDateSQLFormatted(this.inicioVigencia)
          : (this.editedEscala.dt_inicio_vigencia
            ? DateUtils.getDateSQLFormatted(new Date(this.editedEscala.dt_inicio_vigencia))
            : null),
        dt_fim_vigencia: this.fimVigencia
          ? DateUtils.getDateSQLFormatted(this.fimVigencia)
          : (this.editedEscala.dt_fim_vigencia
            ? DateUtils.getDateSQLFormatted(new Date(this.editedEscala.dt_fim_vigencia))
            : null),
        valido_segunda: this.editedEscala.valido_segunda ? 1 : 0,
        valido_terca: this.editedEscala.valido_terca ? 1 : 0,
        valido_quarta: this.editedEscala.valido_quarta ? 1 : 0,
        valido_quinta: this.editedEscala.valido_quinta ? 1 : 0,
        valido_sexta: this.editedEscala.valido_sexta ? 1 : 0,
        valido_sabado: this.editedEscala.valido_sabado ? 1 : 0,
        valido_domingo: this.editedEscala.valido_domingo ? 1 : 0,
        id_quadro: this.editedEscala.id_quadro,
        observacoes: this.editedEscala.observacoes,
      };
      if (includeId) {
        payload.id_escala = this.editedEscala.id_escala;
      }
      return payload;
    },
    escalasVigenciaOverlap(a, b) {
      const aStart = this.vigenciaToMs(a.dt_inicio_vigencia);
      const bStart = this.vigenciaToMs(b.dt_inicio_vigencia);
      if (aStart == null || bStart == null) return false;
      const aEnd = a.dt_fim_vigencia != null ? this.vigenciaToMs(a.dt_fim_vigencia) : null;
      const bEnd = b.dt_fim_vigencia != null ? this.vigenciaToMs(b.dt_fim_vigencia) : null;
      const aHi = aEnd == null ? Infinity : aEnd;
      const bHi = bEnd == null ? Infinity : bEnd;
      return aStart <= bHi && bStart <= aHi;
    },
    escalasWeekdayOverlap(a, b) {
      const keys = [
        "valido_segunda",
        "valido_terca",
        "valido_quarta",
        "valido_quinta",
        "valido_sexta",
        "valido_sabado",
        "valido_domingo"];
      return keys.some((k) => Number(a[k]) === 1 && Number(b[k]) === 1);
    },
    viagensWithChangedVehicle(viagens, originalViagens) {
      const originalByViagem = new Map(
        (originalViagens || []).map((v) => [Number(v.id_viagem), v])
      );
      return (viagens || []).filter((nv) => {
        const orig = originalByViagem.get(Number(nv.id_viagem));
        if (!orig) return true;
        const newVid = nv.id_veiculo == null || nv.id_veiculo === "" ? null : Number(nv.id_veiculo);
        const oldVid = orig.id_veiculo == null || orig.id_veiculo === "" ? null : Number(orig.id_veiculo);
        return newVid !== oldVid;
      });
    },
    findVehicleConflictForNewEscala(escala, viagens, excludeEscalaIds) {
      const exclude = new Set((excludeEscalaIds || []).map((id) => Number(id)));
      for (const other of this.escalas) {
        if (other.id_escala != null && exclude.has(Number(other.id_escala))) continue;
        if (!(other.ativo === 1 || other.ativo === true)) continue;
        if (!this.escalasVigenciaOverlap(escala, other)) continue;
        if (!this.escalasWeekdayOverlap(escala, other)) continue;
        const otherViagens = other.viagens || [];
        for (const nv of viagens) {
          if (nv.id_veiculo == null || nv.id_veiculo === "") continue;
          const vid = Number(nv.id_veiculo);
          for (const ov of otherViagens) {
            if (ov.id_veiculo == null || ov.id_veiculo === "") continue;
            if (Number(ov.id_veiculo) !== vid) continue;
            if (!this.viagensHorarioOverlap(nv, ov)) continue;
            const vehicle = this.veiculos.find((ve) => Number(ve.id_veiculo) === vid);
            return {
              numero_ordem: vehicle ? vehicle.numero_ordem : String(vid),
              otherDescricao: other.descricao || "",
              slot: `${nv.horario_saida || "?"}–${nv.horario_chegada || "?"}`,
              otherSlot: `${ov.horario_saida || "?"}–${ov.horario_chegada || "?"}`,
            };
          }
        }
      }
      return null;
    },
    saveEscalaFromCsv(payload) {
      if (payload && payload.schedules && Array.isArray(payload.schedules) && payload.schedules.length > 0) {
        this.saveEscala(payload);
      }
    },
    prepareEscalasImportacao(data) {
      return data.schedules.map((escala, index) => ({
        ...escala,
        viagens: (data.trips || []).filter((t) => t.quadro_index === index),
      }));
    },
    findEscalaAtivaIndex(escala) {
      return this.escalasAtivas.findIndex((q) => {
        return q.id_quadro == escala.id_quadro &&
          this.escalasVigenciaOverlap(escala, q) &&
          this.escalasWeekdayOverlap(escala, q);
      });
    },
    buildEscalaPayloadForInsert(escala) {
      const payload = { ...escala };
      delete payload.viagens;
      return payload;
    },
    async saveEscalaImportacao(escala) {
      const escalaAtivaIndex = this.findEscalaAtivaIndex(escala);
      const excludeEscalaIds =
        escalaAtivaIndex !== -1
          ? [this.escalasAtivas[escalaAtivaIndex].id_escala]
          : [];
      const vehicleConflict = this.findVehicleConflictForNewEscala(
        escala,
        escala.viagens || [],
        excludeEscalaIds
      );
      if (vehicleConflict) {
        throw new Error(this.$t("schedule.vehicleTimeConflict", vehicleConflict));
      }

      const escalaPayload = this.buildEscalaPayloadForInsert(escala);

      if (escalaAtivaIndex !== -1) {
        const escalaAnterior = { ...this.escalasAtivas[escalaAtivaIndex] };
        escalaAnterior.dt_fim_vigencia = escalaPayload.dt_inicio_vigencia;
        escalaAnterior.dt_inicio_vigencia = DateUtils.getDateSQLFormatted(new Date(escalaAnterior.dt_inicio_vigencia));
        if (escalaAnterior.dt_fim_vigencia < escalaAnterior.dt_inicio_vigencia) {
          escalaAnterior.dt_inicio_vigencia = escalaAnterior.dt_fim_vigencia;
        }
        await apiController.request(apiController.endpoints.updateEscala, {
          data: escalaAnterior,
          silent: true,
        });
      }

      const response = await apiController.request(apiController.endpoints.insertEscala, {
        data: escalaPayload,
        silent: true,
      });

      if (escala.viagens && escala.viagens.length > 0) {
        await this.insertViagensBulkImportacao(response.data.insertId, escala.viagens);
      }

      return response;
    },
    insertViagensBulkImportacao(id_escala, viagens) {
      const temp = viagens.map((v) => {
        return [
          id_escala,
          v.id_viagem,
          v.id_funcionario_motorista,
          v.id_funcionario_cobrador,
          v.id_veiculo
        ];
      });

      return apiController.request(apiController.endpoints.insertViagensescalabulk, {
        data: temp,
        silent: true,
      });
    },
    importarEscalas() {
      this.confirmDialogImportacao = false;
      this.loadingImportacao = true;

      const processarEscala = (index) => {
        if (index >= this.escalasImportacao.length) {
          this.initialize();
          EventBus.$emit('show-alert', {
            tipo: 'success',
            mensagem: this.$t('crudSchedule.messages.importCompleted'),
          });
          this.loadingImportacao = false;
          this.escalasImportacao = [];
          return;
        }

        const escala = this.escalasImportacao[index];
        this.saveEscalaImportacao(escala)
          .then(() => {
            setTimeout(() => {
              processarEscala(index + 1);
            }, 100);
          })
          .catch((error) => {
            const message = error.message || (error.response && error.response.data && error.response.data.mensagem) || String(error);
            EventBus.$emit('show-alert', {
              tipo: 'error',
              mensagem: this.$t('crudSchedule.messages.importErrorDetail', {
                index: index + 1,
                description: escala.descricao || '',
                error: message,
              }),
            });
            this.loadingImportacao = false;
            this.escalasImportacao = [];
            this.initialize();
          });
      };

      processarEscala(0);
    },
    saveEscala(escalaNovo) {
      if (escalaNovo && escalaNovo.schedules && Array.isArray(escalaNovo.schedules) && escalaNovo.schedules.length > 1) {
        this.escalasImportacao = this.prepareEscalasImportacao(escalaNovo);
        this.mensagemProcessamentoImportacao = this.$t('crudSchedule.messages.importSuccess', {
          count: escalaNovo.schedules.length,
          descriptions: escalaNovo.schedules.map((s) => s.descricao).join(", "),
        });
        this.showImportButton = true;
        this.confirmDialogImportacao = true;
        return;
      }

      if (escalaNovo && escalaNovo.schedules && Array.isArray(escalaNovo.schedules) && escalaNovo.schedules.length > 0) {
        this.formValidado = true;
        this.editedEscala = Object.assign({}, escalaNovo.schedules[0]);
        if (escalaNovo.trips) {
          this.editedEscala.viagens = escalaNovo.trips.filter((t) => t.quadro_index === 0);
        }
      }

      if (!this.formValidado && this.$refs.form) {
        this.$refs.form.validate();
      }

      if (this.formValidado) {
        let escala = this.editedEscala;
        if (this.inicioVigencia) {
          this.editedEscala.dt_inicio_vigencia = DateUtils.getDateSQLFormatted(this.inicioVigencia);
        }

        if (this.fimVigencia) {
          this.editedEscala.dt_fim_vigencia = DateUtils.getDateSQLFormatted(this.fimVigencia);
        } else {
          this.editedEscala.dt_fim_vigencia = null;
        }
        if (this.editedIndexEscala === -1) {
          this.operacao = 0;
          let escalaAtivaIndex = this.findEscalaAtivaIndex(escala);

          const excludeEscalaIds =
            this.substitute && escalaAtivaIndex !== -1
              ? [this.escalasAtivas[escalaAtivaIndex].id_escala]
              : [];
          const vehicleConflict = this.findVehicleConflictForNewEscala(
            escala,
            escala.viagens || [],
            excludeEscalaIds
          );
          if (vehicleConflict) {
            EventBus.$emit("show-alert", {
              mensagem: this.$t("schedule.vehicleTimeConflict", vehicleConflict),
              tipo: "error",
            });
            return;
          }

          if (escalaAtivaIndex !== -1 && !this.substitute) {
            this.mensagemdialog = this.$t('schedule.confirmSubstitute');
            this.confirmDialogSubst = true;
          } else {
            if (this.substitute) {
              let escalaAnterior = this.escalasAtivas[escalaAtivaIndex];
              escalaAnterior.dt_fim_vigencia = this.editedEscala.dt_inicio_vigencia;
              escalaAnterior.dt_inicio_vigencia = DateUtils.getDateSQLFormatted(new Date(escalaAnterior.dt_inicio_vigencia));
              if (escalaAnterior.dt_fim_vigencia < escalaAnterior.dt_inicio_vigencia) {
                escalaAnterior.dt_inicio_vigencia = escalaAnterior.dt_fim_vigencia
              }
              apiController.request(apiController.endpoints.updateEscala, {
                data: escalaAnterior,
                onSuccess: () => {
                  apiController.request(apiController.endpoints.insertEscala, {
                    data: this.editedEscala,
                    onSuccess: (response) => {
                      if (this.editedEscala.viagens.length > 0) {
                        this.insertViagensBulk(response.data.insertId);
                      } else {
                        this.updateEscalasTable(response.data.erro);
                      }
                    },
                  });
                },
                onError: (e) => {
                  console.log(e);
                },
              });
            } else {
              apiController.request(apiController.endpoints.insertEscala, {
                data: this.editedEscala,
                onSuccess: (response) => {
                  if (this.editedEscala.viagens.length > 0) {
                    this.insertViagensBulk(response.data.insertId);
                  } else {
                    this.updateEscalasTable(response.data.erro);
                  }
                },
              });
            }
          }
        }
        else {
          const viagensToCheck = this.viagensWithChangedVehicle(
            escala.viagens || [],
            this.escalaOriginal ? this.escalaOriginal.viagens : []
          );
          const vehicleConflict = this.findVehicleConflictForNewEscala(
            escala,
            viagensToCheck,
            this.escalaOriginal ? [this.escalaOriginal.id_escala] : []
          );
          if (vehicleConflict) {
            EventBus.$emit("show-alert", {
              mensagem: this.$t("schedule.vehicleTimeConflict", vehicleConflict),
              tipo: "error",
            });
            return;
          }

          if (this.isEscalaWithinVigencia(this.escalaOriginal)) {
            this.operacao = 0;
            const novaEscala = this.buildEscalaPayloadFromForm();

            this.cancelEscala(
              this.escalaOriginal,
              () => {
                apiController.request(apiController.endpoints.insertEscala, {
                  data: novaEscala,
                  onSuccess: (response) => {
                    if ((this.editedEscala.viagens || []).length > 0) {
                      this.insertViagensBulk(response.data.insertId);
                    } else {
                      this.updateEscalasTable(response.data.erro);
                    }
                  },
                  onError: (e) => {
                    console.log(e);
                  },
                });
              },
              (e) => {
                console.log(e);
              }
            );
          } else {
            this.operacao = 1;
            const escalaUpdate = this.buildEscalaPayloadFromForm(true);
            apiController.request(apiController.endpoints.updateEscala, {
              data: escalaUpdate,
              onSuccess: (response) => {
                if ((this.editedEscala.viagens || []).length > 0) {
                  this.updateViagens();
                } else {
                  this.updateEscalasTable(response.data.erro);
                }
              },
              onError: (e) => {
                console.log(e);
              },
            });
          }
        }
      }
    },
    saveViagem() {
      this.$refs.formViagem.validate();
      if (this.formViagemValidado) {
        this.editedViagem.descricao_sentido = this.sentidos.find((s) => this.editedViagem.id_sentido === s.id_sentido).descricao_sentido;
        this.editedViagem.descricao_turno = this.turnosFiltrados.find((s) => this.editedViagem.id_turno === s.id_turno).descricao_turno;
        this.editedEscala.viagens.push(this.editedViagem);
      }
      this.closeViagem();
    },
    insertViagensBulk(id_escala) {
      let temp = this.editedEscala.viagens.map((v) => {
        return [
          id_escala,
          v.id_viagem,
          v.id_funcionario_motorista,
          v.id_funcionario_cobrador,
          v.id_veiculo
        ];
      });

          apiController.request(apiController.endpoints.insertViagensescalabulk, {
              data: temp,
              onSuccess: (response) => {
              this.updateEscalasTable(response.data.erro);
          },
          });
        },
        updateViagens() {
          apiController.request(apiController.endpoints.deleteViagensbyescala, {
              data: this.editedEscala,
              onSuccess: () => {
              this.insertViagensBulk(this.editedEscala.id_escala);
          },
          });
        },
        formatDate(date) {
            if (!date)
                return null;
            const [year, month, day] = date.split('-');
            return `${day}/${month}/${year}`;
        },
        formatHoraProgramada(date, time) {
            if (!date || !time)
                return null;
            return `${this.formatDate(date)} ${time}`;
        },
        updateEscalasTable(status) {
            if (status) {
                if (this.operacao == 0) {
                    EventBus.$emit('show-alert', { mensagem: this.$t('schedule.updateTable.error.insert'), tipo: 'error' });
                }
                else {
                    if (this.operacao == 1) {
                        EventBus.$emit('show-alert', { mensagem: this.$t('schedule.updateTable.error.update'), tipo: 'error' });
                    }
                    else {
                        EventBus.$emit('show-alert', { mensagem: this.$t('schedule.updateTable.error.delete'), tipo: 'error' });
                    }
                }
            }
            else {
                if (this.operacao == 0) {
                    EventBus.$emit('show-alert', { mensagem: this.$t('schedule.updateTable.success.insert'), tipo: 'success' });
                }
                else {
                    if (this.operacao == 1) {
                        EventBus.$emit('show-alert', { mensagem: this.$t('schedule.updateTable.success.update'), tipo: 'success' });
                    }
                    else {
                        EventBus.$emit('show-alert', { mensagem: this.$t('schedule.updateTable.success.delete'), tipo: 'success' });
                    }
                }
                this.editedEscala = this.defaultEscala;
            }
            this.closeEscala();
            this.initialize();
        },
        updateViagensTable(status) {
            if (status) {
                if (this.operacao == 0) {
                    EventBus.$emit('show-alert', { mensagem: this.$t('schedule.updateTable.error.insert'), tipo: 'error' });
                }
                else {
                    if (this.operacao == 1) {
                        EventBus.$emit('show-alert', { mensagem: this.$t('schedule.updateTable.error.update'), tipo: 'error' });
                    }
                    else {
                        EventBus.$emit('show-alert', { mensagem: this.$t('schedule.updateTable.error.delete'), tipo: 'error' });
                    }
                }
            }
            else {
                if (this.operacao == 0) {
                    EventBus.$emit('show-alert', { mensagem: this.$t('schedule.updateTable.success.insert'), tipo: 'success' });
                }
                else {
                    if (this.operacao == 1) {
                          EventBus.$emit('show-alert', { mensagem: this.$t('schedule.updateTable.success.update'), tipo: 'success' });
                    }
                    else if (this.operacao == 2) {
                        EventBus.$emit('show-alert', { mensagem: this.$t('schedule.updateTable.success.select'), tipo: 'success' });
                    }
                    else {
                        EventBus.$emit('show-alert', { mensagem: this.$t('schedule.updateTable.success.delete'), tipo: 'success' });
                    }
                }
                this.editedEscala = this.defaultEscala;
            }
            this.close();
            this.populaViagens();
        },
        escalonamentoRules() {
          return this.editedViagem.escalonamento > 0 || "Escalonamento é obrigatório e deve ser maior que zero";
        },
    substEscalaAtiva() {
      this.substitute = true;
      this.confirmDialogSubst = false;
      this.saveEscala();
    },
    closeConfirmSubst() {
      this.substitute = false;
      this.confirmDialogSubst = false;
    },
    quadroChanged() {
      this.editedEscala.id_quadro = this.quadroSelected.id_quadro;
      this.editedEscala.viagens = this.viagensPrevistas.filter((v) => v.id_quadro === this.quadroSelected.id_quadro);
      this.editedEscala.valido_segunda = this.quadroSelected.valido_segunda;
      this.editedEscala.valido_terca = this.quadroSelected.valido_terca;
      this.editedEscala.valido_quarta = this.quadroSelected.valido_quarta;
      this.editedEscala.valido_quinta = this.quadroSelected.valido_quinta;
      this.editedEscala.valido_sexta = this.quadroSelected.valido_sexta;
      this.editedEscala.valido_sabado = this.quadroSelected.valido_sabado;
      this.editedEscala.valido_domingo = this.quadroSelected.valido_domingo;
    },
    populaViagensPrevistas() {
      apiController.request(apiController.endpoints.getallViagensprevistas, {
        onSuccess: (response) => {
          this.viagensPrevistas = response.data;
        },
      });
    },
    motoristaChanged(viagem) {
      if (this.repetirEscalonamento) {
        this.editedEscala.viagens = this.editedEscala.viagens.map((v) => {
          if (v.escalonamento === viagem.escalonamento) {
            v.id_funcionario_motorista = viagem.id_funcionario_motorista
          }
          return v
        });
      }
    },
    cobradorChanged(viagem) {
      if (this.repetirEscalonamento) {
        this.editedEscala.viagens = this.editedEscala.viagens.map((v) => {
          if (v.escalonamento === viagem.escalonamento) {
            v.id_funcionario_cobrador = viagem.id_funcionario_cobrador
          }
          return v
        });
      }
    },
    veiculoChanged(viagem) {
      if (this.repetirEscalonamento) {
        this.editedEscala.viagens = this.editedEscala.viagens.map((v) => {
          if (v.escalonamento === viagem.escalonamento) {
            v.id_veiculo = viagem.id_veiculo
          }
          return v
        });
      }
    },
  },
};
</script>